<template>
  <div
    class="carousel-container"
  >
    <Carousel :ref="'carousel-image' + id" @slide-start="slideChange">
      <Slide v-for="(img, index) in images" :key="index">
        <div
          v-if="img === 'Opero_coworking_byznys_hub_clenstvi_praha'"
          class="h-full flex relative"
        >
          <video
            id="hero-video"
            ref="membershipVideo"
            class="h-full object-cover"
            autoplay
            loop
            muted
            playsinline
          >
            <source
              src="https://be.opero.cz/wp-content/uploads/2024/03/Opero_coworking_byznys_hub_clenstvi_praha.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <button
            class="text-white absolute bottom-4 right-4 cursor-pointer z-50 w-11 h-11 rounded-[100%] bg-[#1a1a1a]"
            @click="toggleMute"
          >
            <Icon v-if="videoMuted" name="mdi:volume-off" size="24px" />
            <Icon v-else name="mdi:volume" size="24px" />
          </button>
        </div>
        <div v-else class="flex w-full">
          <NuxtImg sizes="1280px" :src="img" :alt="altTags?.[index] || ''" class="w-full" format="webp" />
        </div>
      </Slide>
      <template #addons>
        <Navigation />
      </template>
    </Carousel>
  </div>
</template>

<script>
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Draggable from "gsap/Draggable";
export default {
  name: "ImageCarousel",
  props: {
    images: {
      type: Array,
      required: true,
    },
    altTags: {
      type: Array,
      required: false
    },
    currentImage: {
      type: Number,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    changeTestimonial: {
      type: Function,
      required: true,
    },
    setCursor: {
      required: true,
      type: Function,
    },
  },
  data() {
    return {
      currentTestimonial: 0,
      sections: [],
      isScrolling: false,
      imgTag: '<img src="/img/arrowDrag.svg" />',
      videoMuted: true,
    };
  },
  watch: {
    currentImage(val, val2) {
      this.$refs["carousel-image" + this.id].slideTo(val);
      this.currentTestimonial = val;
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollToPlugin, Draggable);
    this.sections = gsap.utils.toArray(`.panel${this.id}`);
    window.addEventListener("keydown", this.keyPressed);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.keyPressed);
  },
  methods: {
    toggleMute() {
      this.videoMuted = !this.videoMuted;
      this.$refs.membershipVideo[0].muted =
        !this.$refs.membershipVideo[0].muted;
    },
    restart() {
      this.$refs["carousel-image" + this.id].restartCarousel();
    },
    keyPressed(event) {
      if (event.code === "ArrowLeft" && this.currentTestimonial > 0) {
        this.changeTestimonial(this.currentTestimonial - 1);
      } else if (
        event.code === "ArrowRight" &&
        this.currentTestimonial < this.images.length - 1
      ) {
        this.changeTestimonial(this.currentTestimonial + 1);
      }
    },
    cursorAction() {},
    slideChange(data) {
      if (
        data.slidingToIndex !== Infinity ||
        data.slidingToIndex !== -Infinity
      ) {
        this.changeTestimonial(data?.slidingToIndex);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-container {
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media screen and (min-width: 1280px) {
    padding: 0px 200px;
  }

  #draggable-wrapper {
    display: flex !important;
  }
}

.carousel-container::-webkit-scrollbar {
  display: none;
}

.panimg {
  min-height: 100%;
  object-fit: cover;
  max-height: 700px;
}

.testimonial-containerfirstSpaces {
  max-height: 650px;
}
</style>

<style lang="scss">
.carousel__next {
  background: #ffc800;
  border-radius: 100%;
	width: 48px;
	height: 48px;
	right: 48px;

	@media (max-width: 1024px) {
		width: 32px;
		height: 32px;
		right: 12px;
	}

  &:hover {
    background: #ffc800;
  }
}
.carousel__prev {
  background: #ffc800;
  border-radius: 100%;
	width: 48px;
	height: 48px;
	left: 48px;

	@media (max-width: 1024px) {
		width: 32px;
		height: 32px;
		left: 12px;
	}

  &:hover {
    background: #ffc800;
  }
}

.carousel__icon {
  height: 30px;

	@media (max-width: 1024px) {
		height: 20px;
	}
}
</style>
